"use strict";

// Determine if a node from event.target is a Tab element
function isTabNode(node) {
  return node.nodeName === 'LI' && node.getAttribute('role') === 'tab';
}
module.exports = isTabNode;
//# sourceMappingURL=determineIsTab.js.map